import React, { useState } from "react";
import styles from "./PreQualification.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../../../config";
import { Autocomplete, TextField } from "@mui/material";
import top100Films from "../StepTwo2/data";
import { DatePicker } from "antd";
import { showErrorToast } from "../../utils";
import dayjs from "dayjs";
import { postApi } from "../../AppApis";

function QuestionForm() {
    const navigate = useNavigate();
    const location = useLocation();
    const [closeDate, setCloseDate] = useState();

    // State to track selected options for each question
    const [selectedOptions, setSelectedOptions] = useState({});
    const [specialInstructions, setSpecialInstructions] = useState("");
    const [issue, setIssue] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Handle option selection
    const handleOptionChange = (questionIndex, optionIndex) => {
        setSelectedOptions((prevSelectedOptions) => ({
            ...prevSelectedOptions,
            [questionIndex]: optionIndex,
        }));
    };

    // Handle form submission
    const handleGetQualifiedClick = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            return;
        }

        // Prevent multiple submissions
        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        try {
            // Mapping selected answers to the API request body
            const homeUseOptions = ["Primary Residence", "Secondary Residence", "Investment Property"];
            const homeTypeOptions = ["Single Family", "Town House", "Condominium", "Mobile or Manufactured"];
            const payload = {
                address: location.state.propertyInfo.address,
                city: location.state.propertyInfo.city,
                state: location.state.propertyInfo.state,
                zipCode: location.state.propertyInfo.zipCode,
                knownPropertyIssues: selectedOptions[0] === 0 ? "Yes" : "No",
                issue: issue,
                specialInstructions: specialInstructions,
                project_type: "airebrokers",
            };
            const response = await postApi(`property-services/request_service`, {
                service_name: "TitleServices",
                data: payload,
            });

            navigate("/get-title/title-confirmation");
        } catch (error) {
            console.error("Error submitting form:", error);
            showErrorToast("An error occurred while submitting. Please try again.");
            setIsSubmitting(false);
        }
    };

    const validateForm = () => {
        if (!closeDate || selectedOptions[0] == null) {
            showErrorToast("Please fill all fields before submit!");
            return false;
        } else return true;
    };

    const questions = [
        {
            title: "Known Property Issues (Are there any known issues that could affect the title?)",
            options: ["Yes", "No"],
        },
    ];

    return (
        <form onSubmit={handleGetQualifiedClick} className={`${styles.formContainer} tw-mt-[20px]`}>
            <div className="tw-flex tw-flex-col tw-gap-3">
                <h1 className={styles.formTitle}>Fine-Tune Your Title Services</h1>
                <p className={`${styles.formDescription} tw-text-justify`}>
                    The more details you provide, the better we can anticipate potential issues and tailor solutions to your specific needs.
                    {/* <a href="#" className={styles.privacyLink}>
                                learn more about our privacy Policy
                            </a> */}
                </p>
            </div>
            <div>
                <h2 className={styles.formTitle}>
                    <div className={styles.formTitleText}>Closing Date</div>
                </h2>
                {/* <input type="date" className={`${styles.fieldInput} tw-mt-[10px]`} /> */}
                <DatePicker
                    onChange={(date, dateString) => setCloseDate(dateString)}
                    className={`${styles.fieldInput} tw-mt-[10px]`}
                    disabledDate={(current) => {
                        // Disable dates before today
                        return current && current < dayjs().startOf("day");
                    }}
                    placeholder="DD/MM/YYYY"
                    required
                    allowClear
                    inputReadOnly={true}
                />
            </div>
            {questions.map((question, index) => (
                <section key={index} className={styles.formSection}>
                    <h2 className={styles.formTitle}>
                        <div className={styles.formTitleText}>{question.title}</div>
                    </h2>
                    <div className={styles.optionsContainer}>
                        <div className={`${styles.optionsList} tw-flex tw-flex-row gap-2`}>
                            {question.options.map((option, optionIndex) => (
                                <div className="tw-w-fit" key={optionIndex}>
                                    <input
                                        type="radio"
                                        id={`question${index}-option${optionIndex}`}
                                        name={`question${index}`}
                                        value={option}
                                        className={styles["visually-hidden"]}
                                        checked={selectedOptions[index] === optionIndex}
                                        onChange={() => handleOptionChange(index, optionIndex)}
                                    />
                                    <label
                                        htmlFor={`question${index}-option${optionIndex}`}
                                        className={`${styles.optionItem} tw-border-1 tw-w-fit ${selectedOptions[index] === optionIndex ? "tw-bg-primary hover:tw-bg-primary_hover tw-text-white" : ""}`}
                                    >
                                        {option}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            ))}
            <div>
                <input
                    type="text"
                    value={issue}
                    onChange={(e) => setIssue(e.target.value)}
                    className={`${styles.fieldInput} tw-mt-[10px]`}
                    placeholder="if “Yes”: “Please briefly describe the issue(s)"
                />
            </div>
            <div>
                <h2 className={styles.formTitle}>
                    <div className={styles.formTitleText}>Special Instructions (Optional)</div>
                </h2>
                <input
                    type="text"
                    className={styles.fieldInput}
                    value={specialInstructions}
                    onChange={(e) => setSpecialInstructions(e.target.value)}
                    placeholder="Any special requests or concerns?"
                />
            </div>
            <p className="tw-text-secondary tw-italic tw-mt-[10px]">Even minor details can be important. When in doubt, include it! </p>
            <div className="tw-w-full tw-flex tw-justify-center">
                <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`${styles.submitButton} tw-bg-primary hover:tw-bg-primary_hover tw-w-fit ${isSubmitting ? 'tw-opacity-60 tw-cursor-not-allowed' : ''}`}
                >
                    {isSubmitting ? (
                        <span className="tw-flex tw-items-center tw-gap-2">
                            <svg className="tw-animate-spin tw-h-5 tw-w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="tw-opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="tw-opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                            Submitting...
                        </span>
                    ) : (
                        <span>Review Your Request</span>
                    )}
                </button>
            </div>
        </form>
    );
}

export default QuestionForm;
